import React from "react";
import { motion } from "framer-motion";
import { IMAGES } from "../data/structure";

export default function PageHero({ kicker, title, intro, image = IMAGES.goldStreaks, testid }) {
  return (
    <section data-testid={testid} className="relative overflow-hidden border-b border-jlo-gold/15">
      <img src={image} alt="" aria-hidden="true" loading="eager" className="absolute inset-0 h-full w-full object-cover opacity-20" />
      <div className="absolute inset-0 bg-gradient-to-b from-jlo-bg/80 to-jlo-bg" />
      <div className="relative z-10 mx-auto max-w-5xl px-4 sm:px-6 lg:px-8 py-20 sm:py-28">
        <motion.div initial={{ opacity: 0, y: 18 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.6 }}>
          {kicker && <p className="text-xs sm:text-sm uppercase tracking-[0.3em] text-jlo-gold font-semibold mb-5">{kicker}</p>}
          <h1 className="font-display font-black tracking-tight text-4xl sm:text-5xl lg:text-6xl text-jlo-warm leading-[1.02]">
            {title}
          </h1>
          {intro && <p className="mt-6 max-w-2xl text-base sm:text-lg text-jlo-warm/75 leading-relaxed">{intro}</p>}
        </motion.div>
      </div>
    </section>
  );
}
